/* eslint react/prop-types: 0 */
import { Component } from 'react';
import UnloadGuard from '../../helpers/unloadGuard';

/**
 * Avisa antes de recargar o cerrar la pestaña mientras hay una carga de código en
 * curso.
 *
 * No dibuja nada: existe para que el panel no tenga que manejar el listener, y
 * para que cualquier otra pantalla que compile pueda montarlo igual.
 *
 * `when` es el estado de compilación, que arranca al pedir el build y se apaga al
 * terminar o al fallar. Cubre de más -- también la compilación, no solo el
 * flasheo -- y así está bien: el usuario no tiene forma de saber en qué etapa
 * está, y cortar durante el borrado del flash es lo que deja la placa sin
 * arrancar.
 */
class BuildUnloadGuard extends Component {
  componentDidMount() {
    const { target } = this.props;
    this.guard = new UnloadGuard(target || (typeof window !== 'undefined' ? window : null));
    this.sync();
  }

  componentDidUpdate() {
    this.sync();
  }

  componentWillUnmount() {
    if (this.guard) this.guard.dispose();
    this.guard = null;
  }

  sync() {
    const { when } = this.props;
    if (this.guard) this.guard.set(!!when);
  }

  render() {
    return null;
  }
}

export default BuildUnloadGuard;
